import { OrderCalculation, OrderCalculationCod, UpdateOrderCalculationPaylod } from "../../../../api/types/order"
import { regex } from "../../../../common/regex";
import { FormErrors } from "../../../FieldError"
import { validateTimeRange } from "./common";

export const validateCalculation = (
  data: UpdateOrderCalculationPaylod,
  isCustomTime: boolean,
): [boolean, FormErrors<OrderCalculation>] => {
  let isValid: boolean = true;
  let errors: FormErrors<OrderCalculation> = {}

  if (!data.calculation.loadingDate) {
    errors.loadingDate = "Datum nakládky je povinné pole."
    isValid = false
  }

  if (!data.calculation.loadingTime) {
    errors.loadingTime = "Čas nakládky je povinné pole."
    isValid = false
  }

  if (!data.calculation.unloadingDate) {
    errors.unloadingDate = "Datum vykládky je povinné pole."
    isValid = false
  }

  if (data.calculation.unloadingTime) {
    if (isCustomTime) {
      const err = validateTimeRange(data.calculation.unloadingTime)
      if (err.unloadingTime) {
        errors.unloadingTime = err.unloadingTime
        isValid = false
      }
    }
  } else {
    errors.unloadingTime = "Čas vykládky je povinné pole."
    isValid = false
  }

  if (data.calculation.unloadingIn && !regex.IC.test(data.calculation.unloadingIn)) {
    errors.unloadingIn = "IČ není ve správném formátu. Zadejte prosím 8 číslic."
    isValid = false
  }

  if (data.calculation.unloadingVatId && !regex.DIC.test(data.calculation.unloadingVatId)) {
    errors.unloadingVatId = "DIČ není ve správném formátu."
    isValid = false
  }

  return [isValid, errors]
}

export const validateCalculationCod = (cod: boolean, data: UpdateOrderCalculationPaylod): [boolean, FormErrors<OrderCalculationCod>] => {
  let isValid: boolean = true;
  let errors: FormErrors<OrderCalculationCod> = {}

  if (cod && !data.calculation.cod.amount) {
    errors.amount = "Částka je povinné pole."
    isValid = false
  }

  if (cod && !data.calculation.cod.vs) {
    errors.vs = "Variabilní symbol je povinné pole."
    isValid = false
  }

  if (cod && !data.calculation.cod.bankAccount) {
    errors.bankAccount = "Číslo účtu je povinné pole."
    isValid = false
  }

  return [isValid, errors]
}
